

























import Vue from "vue";

// vue components
import TotalsTab from "./TotalsTab.vue";
import MachineTab from "./MachineTab.vue";
import InstallationTreePathWithResumeDialog from "@/components/InstallationTreePathWithResumeDialog.vue";

// model
import { InstallationContent } from "@/model/data/content/InstallationContent";
import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    components: {
        TotalsTab,
        MachineTab,
        InstallationTreePathWithResumeDialog,
    },
    data() {
        return {
            tabComponent: null,
        };
    },
    props: {
        installation: { type: Object as () => InstallationContent },
    },
    computed: {
        tabs() {
            let res = [];
            res.push({ id: "totals", name: this.$t("deviceContent.totals") });
            this.installation.machines.forEach((machine: Machine) => {
                if (machine.model != "DropVault") {
                    let machineTabTitle = "";
                    if (this.$vuetify.breakpoint.smAndUp) {
                        machineTabTitle = machine.model;
                        if (machine.model != machine.serialNumber) machineTabTitle += " | " + machine.serialNumber;
                    } else {
                        machineTabTitle = machine.model;
                    }
                    res.push({ id: machine.serialNumber, name: machineTabTitle });
                }
            });
            return res;
        },
    },
    methods: {},
});
